(function () {
  'use strict';
  if (window.pmMarqueeVisibilityReady || !window.IntersectionObserver) return;
  window.pmMarqueeVisibilityReady = true;
  var controllers = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(section) {
    if (controllers.has(section)) return;
    var scrolling = section.dataset.pmViewportMarquee === 'scroll';
    var row = section.querySelector(scrolling ? '.logolist--inner' : '.marquee-track, .about-filmstrip__track');
    if (!row) return;
    var visible = false;
    var interacting = false;
    var hovered = false;
    var focused = false;
    var frame = null;
    var resumeTimer = null;
    var lastTime = 0;
    var carry = 0;
    var period = 0;
    var listeners = [];

    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      listeners.push(function () { target.removeEventListener(name, handler, options); });
    }

    function stop() {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      lastTime = 0;
      section.dataset.pmMarqueeState = 'paused';
    }

    function canRun() {
      return visible && !document.hidden && !reducedMotion.matches && !interacting && !hovered && !focused && (!scrolling || period > 0);
    }

    function measure() {
      period = row.scrollWidth > row.clientWidth + 20 ? row.scrollWidth / 2 : 0;
    }

    function loop(now) {
      frame = null;
      if (!canRun()) { stop(); return; }
      if (!lastTime) lastTime = now;
      var elapsed = Math.min(now - lastTime, 32);
      lastTime = now;
      carry += ((window.innerWidth >= 1024 ? 30 : 14) * elapsed) / 1000;
      if (carry >= 1) {
        var step = Math.floor(carry);
        row.scrollLeft = (row.scrollLeft + step) % period;
        carry -= step;
      }
      frame = requestAnimationFrame(loop);
    }

    function sync() {
      if (!canRun()) { stop(); return; }
      section.dataset.pmMarqueeState = 'running';
      if (scrolling && frame === null) frame = requestAnimationFrame(loop);
    }

    function endInteraction() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { interacting = false; sync(); }, 400);
    }

    var intersection = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      section.dataset.pmMarqueeVisible = String(visible);
      sync();
    }, { threshold: 0 });
    var resize = null;
    if (scrolling) {
      measure();
      if (window.ResizeObserver) {
        resize = new ResizeObserver(function () { measure(); sync(); });
        resize.observe(row);
      } else {
        listen(window, 'resize', function () { measure(); sync(); });
        row.querySelectorAll('img').forEach(function (img) { listen(img, 'load', function () { measure(); sync(); }); });
      }
      listen(row, 'mouseenter', function () { hovered = true; sync(); });
      listen(row, 'mouseleave', function () { hovered = false; sync(); });
      listen(row, 'touchstart', function () { interacting = true; clearTimeout(resumeTimer); sync(); }, { passive: true });
      listen(row, 'touchend', endInteraction, { passive: true });
      listen(row, 'touchcancel', endInteraction, { passive: true });
      listen(row, 'focusin', function () { focused = true; sync(); });
      listen(row, 'focusout', function () { queueMicrotask(function () { focused = row.contains(document.activeElement); sync(); }); });
    }
    listen(document, 'visibilitychange', sync);
    listen(reducedMotion, 'change', sync);
    stop();
    intersection.observe(scrolling ? row : row.parentElement);
    controllers.set(section, function () {
      stop();
      clearTimeout(resumeTimer);
      intersection.disconnect();
      if (resize) resize.disconnect();
      listeners.forEach(function (remove) { remove(); });
      controllers.delete(section);
    });
  }

  function scan() {
    document.querySelectorAll('[data-pm-viewport-marquee]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, section) { if (event.target.contains(section)) destroy(); });
  });
})();
